import React from 'react'
import {Link} from 'react-router-dom'
import { withComponentLabel } from '../../utils/debug'

const NavBarSelect = ({
  target,
  label,
  style = 'flex items-center px-2 mx-2 tracking-wider font-bold',
}) => {
  return (
    <Link to={target} className={style}>
      {label}
    </Link>
  )
}

export default withComponentLabel(NavBarSelect, 'NavBarSelect')
